export default __webpack_public_path__ + "static/media/ic-full-test.6f7f498b.svg";